import VEEDHA_EXT_1 from "./VEEDHA_EXT_1";
export default {
  VEEDHA_EXT_1,
};
